// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__u8uei","left":"index_left__YsUwx","right":"index_right__PLwVh"};